module.exports = __webpack_public_path__ + "static/media/pattern.671b0c26.jpg";